import { Palette } from '@mui/material';
import { ProjectionStatuses } from 'business/constants';

export const getStatusColor = (status: ProjectionStatuses): keyof Palette => {
    switch (status) {
        case ProjectionStatuses.TODO:
            return 'orange';
        case ProjectionStatuses.UP_TO_DATE:
        default:
            return 'green';
    }
};
